<template>
    <div class="cmyk-fields-wrapper" v-if="cmyk">
        <label>CMYK</label>
        <div class="cmyk-fields flex">
            <input type="number" v-model="cmyk.cyan" @input="cmykChanged">
            <input type="number" v-model="cmyk.magenta" @input="cmykChanged">
            <input type="number" v-model="cmyk.yellow" @input="cmykChanged">
            <input type="number" v-model="cmyk.black" @input="cmykChanged">
        </div>
    </div>
</template>

<script>
    import Color from "../../../../../Lib/Color";


    export default {
        name : 'cmyk-fields',
        props: {
            cmyk: {}
        },

        methods: {
            cmykChanged() {
                this.validateCMYK();
                let color = Color.fromCMYK();
                this.$emit('cmyk-changed', color, 'cmyk');
            },

            validateCMYK() {
                for(let property in this.cmyk) {
                    if(this.cmyk[property] === '' || this.cmyk[property] < 0) {
                        this.cmyk[property] = 0;
                    }
                    if(this.cmyk[property] > 100) {
                        this.cmyk[property] = 100;
                    }
                }
            }
        }
    }
</script>
  